<ng-content select="[palantir-toolbar-prefix], palantir-toolbar-prefix" />
<ng-content
  select="[palantir-toolbar-main], palantir-toolbar-main, [palantir-toolbar-content], palantir-toolbar-content"
/>
<ng-content select="[palantir-toolbar-suffix], palantir-toolbar-suffix" />
